import {createSlice} from "@reduxjs/toolkit";

const initialWinnerState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  winnerForEdit: undefined,
  lastError: null
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const winnerSlice = createSlice({
  name: "winner",
  initialState: initialWinnerState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // findWinner
    winnerFetched: (state, action) => {
      const { data } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.data = data;
    },
    // createWinner
    winnerCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
    },
    // updateWinner
    winnerUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
    },
    
  }
});
